import { Route, Routes, Navigate } from 'react-router'
import DevToolsLayout from './DevToolsLayout/DevToolsLayout'
import ContactsPage from './Contacts/ContactsPage'
import { Placeholder } from '@/containers/DevToolsNew/DevToolsLayout/styled-components'
import { useTranslation } from 'react-i18next'
import PodUpdaterPage from '@/containers/DevToolsNew/PodUpdater/PodUpdaterPage'
import CommandsPage from '@/containers/DevToolsNew/Commands/CommandsPage'
import CommunicationBoardPage from '@/containers/DevToolsNew/CommunicationBoard/CommunicationBoardPage'
import CachePage from '@/containers/DevToolsNew/Cache/CachePage'
import FeedbackPage from '@/containers/DevToolsNew/Feedback/FeedbackPage'

const BASE_PATH = '/dev-tools-v2'
const DevToolsNew = () => {
  const { t } = useTranslation('devToolsNew')
  return (
    <DevToolsLayout>
      <Routes>
        <Route index element={<Navigate to={`${BASE_PATH}/contacts`} replace />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="pod-updater" element={<PodUpdaterPage />} />
        <Route path="feedback" element={<FeedbackPage />} />
        <Route path="commands" element={<CommandsPage />} />
        <Route path="cache" element={<CachePage />} />
        <Route path="communication" element={<CommunicationBoardPage />} />
        <Route path="*" element={<Navigate to={`${BASE_PATH}/contacts`} replace />} />
      </Routes>
    </DevToolsLayout>
  )
}

export default DevToolsNew
